module.exports = __webpack_public_path__ + "img/3.5bdd2a90.jpg";